import actionTypes from '../actionTypes';

export const FETCH_VERIFICATIONS = actionTypes('FETCH_VERIFICATIONS');
export const FETCH_VERIFICATIONS_DETAILS = actionTypes(
  'FETCH_VERIFICATIONS_DETAILS',
);
export const UPDATE_VERIFICATIONS_DETAILS = actionTypes(
  'UPDATE_VERIFICATIONS_DETAILS',
);
